"use client";

import React, {useContext} from "react";
import ConsentManager from "./ConsentManager";
import {ClientContext} from "../contexts/ClientContext";

function GoogleTag() {
  const {clientCtx} = useContext(ClientContext)

  const loadGManagerFrame = (gaManId: string) => {
    return (
      <>
        <noscript dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${gaManId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
        }}></noscript>
      </>
    );
  }

  return (
    <>
      {clientCtx && clientCtx.gaManId &&
        <>
          {loadGManagerFrame(clientCtx.gaManId)}
          <ConsentManager/>
        </>
      }
    </>
  )
}

export default GoogleTag;